import useSWR from "swr";
import fetcherPost from "../fetchers/fetcherPost";
import { ResponseFetch } from "../models/ResponseFetch";
import { TableRequestObject } from "../models/Requests/TableRequestObject";
import { DictionaryObject } from "../models/DictionaryObject";

function useGetDictionaries(args: TableRequestObject) {
  const { data, error, isLoading, mutate } = useSWR<
    ResponseFetch<DictionaryObject[]>
  >(["/api/dictionary/list", args], ([url, args]) => fetcherPost(url, args), {
    revalidateOnFocus: false,
    keepPreviousData: true,
  });

  return {
    dictionaries: data,
    error,
    isLoading,
    mutate,
  };
}

export default useGetDictionaries;
